import useActiveOrDefaultChain from 'src/common/hooks/web3/useActiveOrDefaultChain'
import { useQuery } from '@tanstack/react-query'
import { useActiveAccount, useActiveWallet } from 'thirdweb/react'
import { initSafeClient } from './safe-client'
import { SafeClient } from '@safe-global/sdk-starter-kit'
import { EIP1193 } from 'thirdweb/wallets'
import { thirdwebClient } from '../thirdweb'

let safeClientInstance: SafeClient | null = null

const useSmartAccount = () => {
  const wallet = useActiveWallet()
  const account = useActiveAccount()
  const chain = useActiveOrDefaultChain()

  const { data: smartAccount, ...accountState } = useQuery({
    queryKey: ['safeClient', account?.address, chain.id],
    queryFn: async () => {
      if (!account?.address || !chain.id) return null

      if (safeClientInstance) {
        const isOwner = await safeClientInstance.isOwner(account.address)
        const clientChainId = await safeClientInstance.protocolKit.getChainId()
        if (isOwner && clientChainId === BigInt(chain.id)) {
          return safeClientInstance
        }
      }

      const newClient = await initSafeClient(
        account.address,
        chain.id,
        EIP1193.toProvider({
          client: thirdwebClient,
          chain,
          wallet: wallet!,
        }),
        chain
      )
      safeClientInstance = newClient
      return newClient
    },
    staleTime: 300000, // 5 minutes
    refetchOnWindowFocus: false,
    enabled: Boolean(account?.address && chain.id),
  })

  const { data: smartAccountInfo, ...infoState } = useQuery({
    queryKey: ['smartAccountAddress', account?.address, chain.id],
    queryFn: async () => {
      const address = await smartAccount?.getAddress()
      const isDeployed = await smartAccount?.isDeployed()
      return {
        address,
        isDeployed,
      }
    },
    staleTime: 300000, // 5 minutes
    refetchOnWindowFocus: false,
    enabled: Boolean(account?.address && chain.id && smartAccount),
  })

  // if (smartAccountInfo) {
  //   smartAccountInfo.address = '0xda15cE4d89c3101133e178Dc2a0510990E5778A6'
  // }

  return {
    smartAccountInfo,
    smartAccount,
    ...accountState,
    isLoading: infoState.isLoading || accountState.isLoading,
  }
}

export default useSmartAccount
